<template>
  <div class="TipDialog">
    <van-popup v-model="showDialog">
      <div class="content">
        <div class="title">{{title}}</div>
        <div class="message">{{message}}</div>
        <div class="btn flex flex-center flex-vertical-center" @click="closeDialog"  >{{ btntext }}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { wxNavigateTo } from '../../utils/WeChatUtil'
export default {
  props: {
    title: {
      type: String,
      default () {
        return '提示'
      }
    },
    btntext: {
      type: String,
      default () {
        return '确定'
      }
    },
    message: {
      type: String,
      default () {
        return '信息提示'
      }
    },
  },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    /**
     * 显示开通体验vip弹框
    */
    showPopup () {
      this.showDialog = true
    },

    /**
     * 关闭弹框事件
    */
    closeDialog () {
      this.showDialog = false
      if (this.btntext !== '确定') {
        this.$emit('define')
        return
      }
      if (this.message === '您的剩余票数不足，请前往会员商城充值' && this.isWechart && this.isAndroid) {
        const { user_content, user_openid } = this.$store.state.userInfo
        wxNavigateTo(`../shop/shop?type=0&userId=${user_content.userId}&openId=${user_openid}`)
      }
      if (this.message === '票数不足，请前往APP使用' && this.isWechart && this.isIos) {
        wxNavigateTo('../user/app/appDownload')
      }
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.TipDialog>:first-child {
  background-color: rgba(0,0,0,.4)
}
.TipDialog>:last-child {
  width: 80%;
  border-radius: 12px;
}
.TipDialog {
  .content {
    padding: 10px 20px 20px;
    background-color: #ffffff;
    .title {
      padding: 20px 0;
      text-align: center;
      font-size: 32px;
    }
    .message {
      color: #656565;
      font-size: 26px;
      text-align: center;
      padding: 50px 0
    }
    .btn {
      background-color: #5572FD;
      margin: 0 auto;
      color: #ffffff;
      border-radius: 40px;
      font-size: 28px;
      height: 80px;
      margin-top: 20px;
    }
  }
}
</style>
